module.exports = __webpack_public_path__ + "img/empty-box.61d7353e.svg";